import { clientAPI } from '../configs/configs'

export default class Voucher {
    static async insertConsumerB2C( form ) {
        return new Promise((res, rej) => {
            clientAPI.post('/customers/consumers/b2c', { ...form })
                .then((resp) => res(resp.data))
                .catch((err) => rej(err.response))
        })
    }

    static async pesqCep( cep ) {
        return new Promise((res, rej) => {
            clientAPI.get(`/addressbook/cep/${cep}`)
                .then((resp) => res(resp.data))
                .catch((err) => rej(err.response))
        })
    }
}